"use strict";
exports.__esModule = true;
exports.formLanguages = void 0;
var formLanguages = [
    { id: 1, name: 'English' },
    { id: 2, name: 'Spanish' },
    { id: 3, name: 'Chinese' },
    { id: 4, name: 'Korean' },
    { id: 5, name: 'Laotian' },
    { id: 6, name: 'Russian' },
    { id: 7, name: 'Vietnamese' },
];
exports.formLanguages = formLanguages;
//# sourceMappingURL=formLanguages.js.map